
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dropshipping-video-ads-maker",
      function () {
        return require("private-next-pages/dropshipping-video-ads-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dropshipping-video-ads-maker"])
      });
    }
  